import { render, staticRenderFns } from "./TitlePie.vue?vue&type=template&id=bddeb4de&scoped=true"
import script from "./TitlePie.vue?vue&type=script&lang=js"
export * from "./TitlePie.vue?vue&type=script&lang=js"
import style0 from "./TitlePie.vue?vue&type=style&index=0&id=bddeb4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddeb4de",
  null
  
)

export default component.exports